export default "__VITE_ASSET__DpssqVQa__"